import { sendToGTM } from '../context/utils/GoogleTagManager';
export var formStart = function formStart(props) {
  var identifier = props.identifier,
      name = props.name;
  var event = {
    event: 'form_start',
    detailed_event: 'Form Start',
    event_data: {
      identifier: identifier ? identifier : '',
      name: name ? name : ''
    }
  };
  sendToGTM({
    data: event
  });
};